import { useClientFrame } from '../advisor/useClientFrame';
import { FIRM_SUGGESTIONS, SUGGESTIONS } from './constants';

export type AssistantStarterKind = 'family' | 'firm';

/**
 * Which empty-chat starters to show: the household ones, or the firm ones in an advisory
 * firm's own workspace (steward-app#1815). Only the copy follows this; which assistant
 * actually answers is the façade's decision from the workspace's packs, and a firm member
 * in a client's household workspace gets the household starters, like the household
 * assistant.
 */
export function useAssistantStarters(): { kind: AssistantStarterKind; suggestions: readonly string[] } {
  const { inFirmWorkspace } = useClientFrame();
  return inFirmWorkspace
    ? { kind: 'firm', suggestions: FIRM_SUGGESTIONS }
    : { kind: 'family', suggestions: SUGGESTIONS };
}
